import { useCallback } from 'react';
import { isEmptyId, ILayoutComponent, isFormComponent } from '@diana/core';
import { useCreateEmptySection } from './useCreateEmptySection';
import { useSyncComponentNameAndDataPath } from './useSyncComponentNameAndDataPath';

interface IUsePrepareComponentToAddInLayoutProps {
  parentId: string;
  layoutId: string;
  taskId: string | null;
  stepId: string | null;
  flowId: string | null;
}

export const usePrepareComponentToAddInLayout = (props: IUsePrepareComponentToAddInLayoutProps) => {
  const { parentId, layoutId, taskId, stepId, flowId } = props;

  const createEmptySection = useCreateEmptySection();

  const syncComponentNameAndDataPath = useSyncComponentNameAndDataPath({
    layoutId,
    taskId,
    stepId,
    flowId,
  });

  return useCallback(
    (component: ILayoutComponent) => {
      if (isFormComponent(component) && isEmptyId(parentId)) {
        let section = createEmptySection();
        section = syncComponentNameAndDataPath(section);
        component = { ...component, parentId: section.id };
        component = syncComponentNameAndDataPath(component);
        return [section, component];
      }
      return [component];
    },
    [parentId, createEmptySection, syncComponentNameAndDataPath],
  );
};
